/**
 * @Author:      jiang.weiwei
 * @DateTime:    2017-12-06 20:13:08
 * @Description: 后台-ugc稿件管理
 */
'use strict';
angular.module("ugcManageModule",[
    'ugcManageRouterModule',
    'userContributionModule',//用户投稿
    'userBurstModule',//用户爆料
    'submissionClassifiyModule',//投稿分类
]).
controller('userManagementCtrl', ['$scope',function($scope){
    initStatus();
    initData();
    /**
     * [initStatus description] 初始化参数
     */
    function initStatus(){
        $scope.status = {
            inputData:''
        }
    };

    function initData(){

    };
}]);